import React, { Component } from 'react';
import { node, bool } from 'prop-types';
import { Transition } from 'react-transition-group';

const defaultStyle = {
  transition: '500ms ease-in',
  transitionProperty: 'opacity, transform',
};

const transitionStylesToLeft = {
  entering: {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    transform: 'translateX(100%)',
  },
  entered: {
    display: 'block',
    position: 'relative',
    top: 0,
    opacity: 1,
    transform: 'translateX(0)',
  },
  exiting: {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    transform: 'translateX(-100%)',
  },
  exited: {
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    zIndex: -1,
    transform: 'translateX(100%)',
  },
};

const transitionStylesToRight = {
  entering: {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    transform: 'translateX(-100%)',
  },
  entered: {
    display: 'block',
    position: 'relative',
    top: 0,
    opacity: 1,
    transform: 'translateX(0)',
  },
  exiting: {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    transform: 'translateX(100%)',
  },
  exited: {
    position: 'absolute',
    width: '100%',
    top: 0,
    opacity: 0,
    zIndex: -1,
    transform: 'translateX(-100%)',
  },
};

export default class SlideInOutTransition extends Component {
  static propTypes = {
    children: node.isRequired,
    in: bool,
    toRight: bool,
  };

  static defaultProps = {
    toRight: false,
    in: false,
  };

  state = {};

  render() {
    const { children, in: inProp, toRight } = this.props;

    const transitionStyles = toRight
      ? transitionStylesToRight
      : transitionStylesToLeft;

    return (
      <Transition
        in={inProp}
        timeout={{
          enter: 0,
          exit: 500,
        }}
      >
        {state => (
          <div style={Object.assign({}, defaultStyle, transitionStyles[state])}>
            {children}
          </div>
        )}
      </Transition>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/authCard/AnimatedCard/components/SlideInOutTransition/SlideInOutTransition.jsx